import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { useSpace } from "../../../hooks/useSpace";
import { OpenQuoteWithSubTopic } from "../../../types";
import { keys } from "./keys";

/** Statuses that settle a quote; every other status awaits a decision (see normalizeQuoteStatus). */
const SETTLED_QUOTE_STATUSES = '(accepted,approved,refused,rejected)';

async function fetchOpenQuotes(spaceId: string): Promise<OpenQuoteWithSubTopic[]> {
  const { data, error } = await apiClient
    .from('subject_quotes')
    .select('*, sub_topics!inner(id, name, state, archived_at, topics!inner(space_id))')
    .not('status', 'in', SETTLED_QUOTE_STATUSES)
    .eq('sub_topics.topics.space_id', spaceId)
    .eq('sub_topics.state', 'pending')
    .is('sub_topics.archived_at', null)
    .order('date_received', { ascending: false });

  if (error) {
    throw error;
  }

  return (data ?? []) as unknown as OpenQuoteWithSubTopic[];
}

export function useGetOpenQuotes() {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.openQuotes(currentSpace?.id ?? ''),
    queryFn: () => fetchOpenQuotes(currentSpace!.id),
    enabled: !!currentSpace?.id,
    staleTime: _3_DAYS,
  });
}
